export default "__VITE_ASSET__d3cdc4fb__"